import { BulkPrice } from './bulk-price';
import { CustomDimensions } from './custom-dimensions';

export class PrintProductionDto {
  type?: string;
  subType?: string;
  subTypeComment?: string;
  material?: string;
  otherMaterialComment?: string;
  dimensions?: string;
  customDimensions?: CustomDimensions;
  dimensionsComment?: string;
  printMethod?: string;
  nbColors?: string;
  secondaryNbColors?: string;
  filmCost?: number;
  sieveChange?: number;
  bulkPrices?: BulkPrice[];
  id?: number;
  linkedToSign: boolean;
  extraInfo?: string;

  constructor(init?: Partial<PrintProductionDto>) {
    Object.assign(this, init);

    this.printMethod = init?.printMethod ?? null;
    this.material = init?.material ?? null;
    this.dimensions = init?.dimensions ?? null;
    this.nbColors = init?.nbColors ?? null;
    this.customDimensions = init?.customDimensions ?? new CustomDimensions();

    if (!init?.bulkPrices) {
      this.bulkPrices = BulkPriceHeaders.map(
        (bulkNumber) =>
          new BulkPrice({
            bulkNumber,
            unitPrice: null,
            capShape: null,
            descending: null,
            reflecting: null,
          })
      );
    } else {
      this.bulkPrices = init.bulkPrices;
    }
  }
}

export const BulkPriceHeaders = [1, 5, 10, 25, 50, 100, 200, 500];
